<template>
    <div
        class="el-radio-group"
        role="radiogroup"
        @input="setModel">
        <slot />
    </div>    
</template>

<script>
import emitter from '../../utilities/emitter'

export default {
    name: 'app-radio-group',
    mixins: [emitter],
    props: {
        value: {}
    },
    data() {
        return {
            internalValue: null
        }
    },
    computed: {
        model: {
            get() {
                return this.internalValue || this.value
            },
            set(val) {
                this.internalValue = val
                this.$emit('input', val)
            }
        }
    },
    created() {
        this.$on('handleChange', value => {
            this.$emit('change', value);
        });
    },
    methods: {
        setModel(evt) {
            this.model = evt.target._value
        }
    },
    watch: {
        value() {
            this.dispatch('app-form-item', 'app.form.change', [this.value]);
        }
    }

}
</script>

<style lang="stylus" scoped>

</style>
